const getMinMax = (numbers: number[]) => {
  const min = Math.min(...numbers)
  const max = Math.max(...numbers)

  return { min, max }
}

export const getBounds = (
  points: google.maps.LatLngLiteral[],
): google.maps.LatLngBounds => {
  const latBounds = getMinMax(points.map((d) => d.lat))
  const lngBounds = getMinMax(points.map((d) => d.lng))

  const sw = new google.maps.LatLng(latBounds.min, lngBounds.min)
  const ne = new google.maps.LatLng(latBounds.max, lngBounds.max)

  return new google.maps.LatLngBounds(sw, ne)
}

export const styles: google.maps.MapTypeStyle[] = [
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
]
